"use client"

import dynamic from "next/dynamic"

// Lazy load the CartButton component
const CartButton = dynamic(
  () =>
    import("@/features/cart/components/cart-button").then(
      (mod) => mod.CartButton
    ),
  {
    loading: () => (
      <div
        className="size-11 rounded-full relative shrink-0"
        aria-hidden="true"
      />
    ),
  }
)

export function ClientCartButton() {
  return <CartButton />
}
